import { isTenantAdministrator } from './administratorAccess';

export const canReadArticles = user => isTenantAdministrator(user) || Boolean(user?.roles?.some(role => role.key === 'VERWALTER'));
// Existing document master-data writes use betriebe.manage (standard administrator).
export const canManageArticles = isTenantAdministrator;
